export const VARIANT_L = 'L';

export interface InputCardProps {
  isDisabled: boolean;
  isChecked: boolean;
  handleClick: () => void;
  variant?: typeof VARIANT_L;

  children?: React.ReactNode;
}
